/**
* @summary - Component that Provides Work Group Creation Page
* @author Aro J
* @since 2024-07-15
*/
import React from 'react'
import SideBar from '../../components/commoncomponents/SideBar'
import Header from '../../components/commoncomponents/Header'
import Footer from '../../components/commoncomponents/Footer'
import { Layout, Content, ContentBody } from '../../assets/styled-components/layout'
import CreateFemsDrawing from '../../components/femsdrawingcomponents/CreateFemsDrawing'

function FemsDrawingCreate({renderPageContent}) {
    return (
        <>
                        <CreateFemsDrawing renderPageContent={renderPageContent}/>
                       
                       
        </>
    )
}

export default FemsDrawingCreate;